console.log('google auth props', window.__env.isProduction, window.__env.googleKey);
console.log('google auth props', window.__env);

export default Object.freeze({
  asclientid: window.__env.isProduction,
  googlekey: window.__env.googleKey,
  // googlekey: window.__env.isProduction ? window.__env.googleClient : window.__env.googleKey,
});
